import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
const IconAffirmLogo = t0 => {
  const $ = _c(11);
  const {
    width: t1,
    height: t2,
    color: t3
  } = t0;
  const width = t1 === undefined ? 23 : t1;
  const height = t2 === undefined ? 26 : t2;
  const color = t3 === undefined ? "gray" : t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      maskType: "luminance"
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <mask id="mask0_8975_43162" style={t4} width="175" height="129" x="0" y="0" maskUnits="userSpaceOnUse"><path fill="#fff" d="M174.82 0H0v128.16h174.82V0z" /></mask>;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  let t7;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <path d="M28.53 125.9c-7.26-11.06-11.49-24.26-11.49-38.45 0-38.76 31.53-70.29 70.29-70.29 38.76 0 70.29 31.53 70.29 70.29 0 14.18-4.24 27.39-11.49 38.45h19.68a86.89 86.89 0 008.93-38.45c0-48.2-39.21-87.4-87.4-87.4-48.19 0-87.4 39.21-87.4 87.4a86.89 86.89 0 008.93 38.45h19.66z" />;
    t7 = <path d="M88.51 45.92c-12.8 0-27.53 6.03-35.53 12.41l7.3 15.37c6.41-5.87 16.78-10.88 26.13-10.88 8.89 0 13.79 2.97 13.79 8.96 0 4.03-3.26 6.3-9.4 6.86-23.06 2.12-40.98 9.32-40.98 27.02 0 14.04 10.12 22.52 26.77 22.52 11.14 0 19.89-6.19 24.61-14.36v12.07h20.76V75.3c.01-20.89-14.52-29.38-33.45-29.38zm-6.06 66.04c-6.73 0-10.42-2.88-10.42-7.61 0-9.86 12.05-12.24 27.74-12.24 0 10.32-6.91 19.85-17.32 19.85z" />;
    $[2] = t6;
    $[3] = t7;
  } else {
    t6 = $[2];
    t7 = $[3];
  }
  let t8;
  if ($[4] !== color) {
    t8 = <g clipPath="url(#clip0_8975_43162)">{t5}<g fill={color} mask="url(#mask0_8975_43162)">{t6}{t7}</g></g>;
    $[4] = color;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <defs><clipPath id="clip0_8975_43162"><path fill="#fff" d="M0 0H175V129H0z" /></clipPath></defs>;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== height || $[8] !== t8 || $[9] !== width) {
    t10 = <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 180 120">{t8}{t9}</svg>;
    $[7] = height;
    $[8] = t8;
    $[9] = width;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  return t10;
};
IconAffirmLogo.propTypes = {
  color: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default IconAffirmLogo;